import Flickity from 'flickity';
import select from 'dom-select';
import throttle from 'lodash.throttle';
import 'flickity-imagesloaded';
import 'flickity-fade';

export default (el) => {
  const ui = {
    el,
    container: select('.carousel__container', el),
    cells: select.all('.carousel__cell', el),
    index: select('span#index')
  };

  if (ui.cells.length > 1) {
    // initialize carousel with different options based on class
    if (el.classList.contains('carousel--card')) {
      const flkty = new Flickity(ui.container, {
        adaptiveHeight: false,
        autoPlay: 0,
        cellAlign: 'left',
        draggable: false,
        fade: false,
        groupCells: true,
        imagesLoaded: true,
        pageDots: false,
        wrapAround: false,
        prevNextButtons: true,
        lazyLoad: true,
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 80, y2: 30,
          x3: 50
        }
      });

      //counter -- not used
      flkty.on('change', (index) => {
        ui.index.innerHTML = (index + 1);
      });
  
      // resize carousel cells on (throttled) window.resize
      window.addEventListener('resize', throttle(() => {
        flkty.resize();
      },
      250,
      {
        trailing: true,
        leading: true
      }));
    }
    else if (el.classList.contains('carousel--gallery')) {
      const flkty = new Flickity(ui.container, {
        adaptiveHeight: true,
        autoPlay: 3000,
        cellAlign: 'center',
        draggable: true,
        fade: true,
        groupCells: 1,
        imagesLoaded: true,
        pageDots: true,
        wrapAround: true,
        prevNextButtons: true,
        lazyLoad: true,
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 80, y2: 30,
          x3: 50
        }
      });

      //counter -- not used
      flkty.on('change', (index) => {
        ui.index.innerHTML = (index + 1);
      });
  
      // resize carousel cells on (throttled) window.resize
      window.addEventListener('resize', throttle(() => {
        flkty.resize();
      },
      250,
      {
        trailing: true,
        leading: true
      }));
    }
    else {
      const flkty = new Flickity(ui.container, {
        adaptiveHeight: true,
        draggable: true,
        fade: true,
        imagesLoaded: true,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: true,
        lazyLoad: true,
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 80, y2: 30,
          x3: 50
        }
      });

      // counter -- not used
      flkty.on('change', (index) => {
        ui.index.innerHTML = (index + 1);
      });

      // resize carousel cells on (throttled) window.resize
      window.addEventListener('resize', throttle(() => {
        flkty.resize();
      },
      250,
      {
        trailing: true,
        leading: true
      }));
    }
  }

  if (1 + 1) {

  } else if (1 + 2) {

  } else {

  }
};
